import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowStatus } from '../../shared-services/pipeline-workflow.model';

type PipelineTopbarWidgetData = {
  workflowName?: string;
  version?: string;
  status?: WorkflowStatus;
  saveStatus?: 'idle' | 'saving' | 'saved';
  onBackClick?: () => void;
  onValidateClick?: () => void;
  onPublishClick?: () => void;
};

@Component({
  selector: 'app-pipeline-topbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pipeline-topbar.component.html',
  styleUrl: './pipeline-topbar.component.scss',
})
export class PipelineTopbarComponent {
  @Input() workflowName = '';
  @Input() version = '';
  @Input() status: WorkflowStatus = 'DRAFT';
  @Input() saveStatus: 'idle' | 'saving' | 'saved' = 'idle';
  @Input() set data(value: PipelineTopbarWidgetData | null | undefined) {
    if (!value) return;
    this.workflowName = value.workflowName ?? this.workflowName;
    this.version = value.version ?? this.version;
    this.status = value.status ?? this.status;
    this.saveStatus = value.saveStatus ?? this.saveStatus;
    this.onBackClick = value.onBackClick;
    this.onValidateClick = value.onValidateClick;
    this.onPublishClick = value.onPublishClick;
  }

  @Output() backClick = new EventEmitter<void>();
  @Output() validateClick = new EventEmitter<void>();
  @Output() publishClick = new EventEmitter<void>();

  private onBackClick?: () => void;
  private onValidateClick?: () => void;
  private onPublishClick?: () => void;

  handleBackClick(): void {
    this.backClick.emit();
    this.onBackClick?.();
  }

  handleValidateClick(): void {
    this.validateClick.emit();
    this.onValidateClick?.();
  }

  handlePublishClick(): void {
    this.publishClick.emit();
    this.onPublishClick?.();
  }
}
